import XFetch from '../../common/x-fetch'
import Actions from '../actions'
import UserFacingAPIReturnTypes from '../../common/UserFacingAPIReturnTypes'

function setIsInit (isInit) {
  return {
    type: Actions.SYSTEM_SET_IS_INIT,
    payload: isInit
  }
}

function getServerTimeOffset () {
  return (dispatch) => {
    XFetch.get(`/api/get_server_time`)
    .then(result => {
      //console.log(result)
      //console.log(Date.now() * 0.001)
      var offset = result.data.server_time - (Date.now() * 0.001)
      console.log(`clock offset: ${offset}`)
      dispatch({
        type: Actions.SYSTEM_SET_SERVER_TIME_OFFSET,
        payload: offset
      })
    })
    .catch(err => {
      dispatch(handleUserFacingMessages(err))
    })
  }
}

function getConstants () {
  return (dispatch) => {
    XFetch.get(`/api/get_constants`)
    .then(result => {
      dispatch({
        type: Actions.SYSTEM_SET_CONSTANTS,
        payload: result.data
      })
    })
    .catch(err => {
      dispatch(handleUserFacingMessages(err))
    })
  }
}

function getGameTypes () {
  return (dispatch) => {
    XFetch.get(`/api/get_game_types`)
    .then(result => {
      dispatch({
        type: Actions.SYSTEM_SET_GAME_TYPES,
        payload: result.data
      })
    })
    .catch(err => {
      dispatch(handleUserFacingMessages(err))
    })
  }
}

function setSystemMessage (systemMessage) {
  return {
    type: Actions.SYSTEM_SET_SYSTEM_MESSAGE,
    payload: systemMessage,
  } 
}

function removeSystemMessage (messageId) {
  return {
    type: Actions.SYSTEM_DELETE_SYSTEM_MESSAGE,
    payload: messageId,
  }
}

function handleUserFacingMessages (result) {
  return (dispatch) => {
    console.log(result)

    let mType = result?.data?.message?.type || ''
    mType = UserFacingAPIReturnTypes?.[mType] || UserFacingAPIReturnTypes['error']
    // for game messages as well
    if (result?.data?.message?.success) mType = UserFacingAPIReturnTypes['success']

    let mTexts = []
    // system type messages
    if (result?.data?.message?.text) mTexts.push(result.data.message.text)
    //  game type messages
    if (result?.data?.message?.messages) {
      mTexts = mTexts.concat(result.data.message.messages)
    }
    // something else went wrong
    if (!mTexts.length) mTexts.push('unknown')
    mTexts.forEach(mText => {
      dispatch( 
        setSystemMessage({
          type: mType,
          message: mText,
        })
      )
    })
  }
}

export default {
  setIsInit,
  getServerTimeOffset,
  getConstants,
  getGameTypes,
  setSystemMessage,
  removeSystemMessage,
  handleUserFacingMessages,
}
